<template>
  <a-tabs defaultActiveKey="7">
    <a-tab-pane tab="Chartering Position" key="1">
      <h3>Chartering</h3>
      <a-divider></a-divider>
      <a-button
        type="primary"
        :style="{ marginBottom: '30px' }"
        @click="modal_create_daily_hire_visible = true"
      >
        Create Chartering Position
      </a-button>

      <a-modal
        title="Please Daily Hire Position Info"
        :visible="modal_create_daily_hire_visible"
        @ok="submit_create_dh"
        @cancel="modal_create_daily_hire_visible = false"
      >
        <a-form layout="horizontal" width="300">
          <a-form-item
            label="Vessel Name:"
            :labelCol="{ span: 6 }"
            :wrapperCol="{ span: 16 }"
          >
            <a-input size="small" v-model="charter.vessel_name"></a-input>
          </a-form-item>

          <a-form-item
            label="Charter End:"
            :labelCol="{ span: 6 }"
            :wrapperCol="{ span: 16 }"
          >
            <a-date-picker size="small" v-model="charter.date_obj" />
          </a-form-item>

          <a-form-item
            label="Charter Start:"
            :labelCol="{ span: 6 }"
            :wrapperCol="{ span: 16 }"
          >
            <a-date-picker size="small" v-model="charter.start_obj" />
          </a-form-item>

          <a-form-item
            label="Charter End:"
            :labelCol="{ span: 6 }"
            :wrapperCol="{ span: 16 }"
          >
            <a-date-picker size="small" v-model="charter.end_obj" />
          </a-form-item>

          <a-form-item
            label="FFA Ratio(%):"
            :labelCol="{ span: 6 }"
            :wrapperCol="{ span: 16 }"
          >
            <a-input
              size="small"
              v-model="charter.ratio"
              type="number"
              step="1"
              min="80"
              max="200"
            />
          </a-form-item>
        </a-form>
      </a-modal>

      <a-table size="small" :dataSource="charters" :columns="charter_columns" rowKey="id">
        <!-- operation -->
        <template slot="operation" slot-scope="text, record">
          <div class="editable-row-operations">
            <span v-if="record.editable">
              <a-popconfirm title="About to Save?" @confirm="() => save_dh(record.id)">
                <a>Save</a>
              </a-popconfirm>

              <a-popconfirm
                title="Sure to cancel?"
                @confirm="() => cancel_dh_change(record.id)"
              >
                <a>Cancel</a>
              </a-popconfirm>
            </span>

            <span v-else>
              <a @click="() => edit_dh(record.id)">Edit</a>
              <a-popconfirm title="Sure to Delete?" @confirm="() => delete_dh(record.id)">
                <a>Delete</a>
              </a-popconfirm>
            </span>
          </div>
        </template>

        <template
          v-for="col in ['vessel_name', 'date', 'start', 'end', 'ratio', 'exclude']"
          :slot="col"
          slot-scope="text, record"
        >
          <div :key="col" style="text-align: center">
            <template v-if="record.editable">
              <a-input
                v-if="col == 'vessel_name'"
                size="small"
                v-model="record.vessel_name"
              ></a-input>

              <a-date-picker
                v-if="col == 'date'"
                size="small"
                v-model="record.date_obj"
                @change="(e) => change_dh_change(e, record, col)"
              ></a-date-picker>
              <a-date-picker
                v-if="col == 'start'"
                size="small"
                v-model="record.start_obj"
                @change="(e) => change_dh_change(e, record, col)"
              ></a-date-picker>
              <a-date-picker
                v-if="col == 'end'"
                size="small"
                v-model="record.end_obj"
                @change="(e) => change_dh_change(e, record, col)"
              ></a-date-picker>

              <a-input
                v-if="col == 'ratio'"
                size="small"
                v-model="record.ratio"
                type="number"
              ></a-input>
              <a-select
                v-if="col == 'exclude'"
                mode="multiple"
                size="small"
                :style="{ width: '200px' }"
                :defaultValue="record.exclude"
                v-model="record.exclude"
              >
                <a-select-option v-for="r in record.month_array" :key="r" :value="r">{{
                  r
                }}</a-select-option>
              </a-select>
            </template>

            <template v-else>{{ text }}</template>
          </div>
        </template>
      </a-table>
    </a-tab-pane>

    <a-tab-pane tab="Freight Position" key="2">
      <h3>Freight Position</h3>
      <a-divider></a-divider>
      <a-button
        type="primary"
        @click="modal_create_freigth_visible = true"
        :style="{ marginBottom: '30px' }"
        >Create Freight
      </a-button>

      <a-modal
        title="Please Freight Position Info"
        :visible="modal_create_freigth_visible"
        @ok="submit_freight_create"
        @cancel="modal_create_freigth_visible = false"
      >
        <a-form layout="horizontal" width="300">
          <a-form-item
            label="Charter:"
            :labelCol="{ span: 6 }"
            :wrapperCol="{ span: 16 }"
          >
            <a-input size="small" v-model="freight.charterer"></a-input>
          </a-form-item>

          <a-form-item
            label="Est Loading Start:"
            :labelCol="{ span: 6 }"
            :wrapperCol="{ span: 16 }"
          >
            <a-date-picker size="small" v-model="freight.loading_start_obj" />
          </a-form-item>

          <a-form-item
            label="Laycan Start:"
            :labelCol="{ span: 6 }"
            :wrapperCol="{ span: 16 }"
          >
            <a-date-picker size="small" v-model="freight.loading_period_start_obj" />
          </a-form-item>

          <a-form-item
            label="Laycan End:"
            :labelCol="{ span: 6 }"
            :wrapperCol="{ span: 16 }"
          >
            <a-date-picker size="small" v-model="freight.loading_period_end_obj" />
          </a-form-item>

          <a-form-item
            label="Freight:"
            :labelCol="{ span: 6 }"
            :wrapperCol="{ span: 16 }"
          >
            <a-input size="small" type="number" step="0.01" v-model="freight.freight" />
          </a-form-item>

          <a-form-item label="PDA:" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }">
            <a-input size="small" type="number" step="1" v-model="freight.pda" />
          </a-form-item>
        </a-form>
      </a-modal>

      <a-table
        size="small"
        :dataSource="freight_by_charter"
        :columns="freight_outter_column"
        rowKey="charterer"
      >
        <template slot="expandedRowRender" slot-scope="text, record">
          <a-table
            style="margin: 15px"
            :columns="freight_column"
            :dataSource="
              freights.filter((f) => f.charterer == freights[record].charterer)
            "
            :pagination="false"
            rowKey="id"
          >
            <template slot="operation" slot-scope="text, record">
              <div class="editable-row-operations">
                <span v-if="record.editable">
                  <a-popconfirm
                    title="About to Save?"
                    @confirm="() => save_freight(record.id)"
                  >
                    <a>Save</a>
                  </a-popconfirm>

                  <a-popconfirm
                    title="Sure to cancel?"
                    @confirm="() => cancel_freight_change(record.id)"
                  >
                    <a>Cancel</a>
                  </a-popconfirm>
                </span>

                <span v-else>
                  <a @click="() => edit_freight(record.id)">Edit</a>
                  <a-popconfirm
                    title="Sure to Delete?"
                    @confirm="() => delete_freight(record.id)"
                  >
                    <a>Delete</a>
                  </a-popconfirm>
                </span>
              </div>
            </template>

            <template
              v-for="col in [
                'charterer',
                'loading_start',
                'loading_period_start',
                'loading_period_end',
                'freight',
                'pda',
                'quantity',
                'oil_consumption',
                'exclude',
                'ballast_length',
                'loading_length',
                'voyage_length',
                'discharge_length',
              ]"
              :slot="col"
              slot-scope="text, record"
            >
              <div :key="col" style="text-align: center">
                <template v-if="record.editable">
                  <a-input v-if="col == 'charterer'" v-model="record.charterer"></a-input>
                  <a-date-picker
                    v-if="col == 'loading_start'"
                    size="small"
                    v-model="record.loading_start_obj"
                    @change="(e) => change_freight_change(e, record, col)"
                  ></a-date-picker>

                  <a-date-picker
                    v-if="col == 'loading_period_start'"
                    size="small"
                    v-model="record.loading_period_start_obj"
                    @change="(e) => change_freight_change(e, record, col)"
                  >
                  </a-date-picker>
                  <a-date-picker
                    v-if="col == 'loading_period_end'"
                    size="small"
                    v-model="record.loading_period_end_obj"
                    @change="(e) => change_freight_change(e, record, col)"
                  ></a-date-picker>

                  <a-input
                    v-if="col == 'freight'"
                    size="small"
                    :value="text"
                    @change="(e) => change_freight_change(e, record, col)"
                    type="number"
                  ></a-input>
                  <a-input
                    v-if="col == 'pda'"
                    size="small"
                    :value="text"
                    @change="(e) => change_freight_change(e, record, col)"
                    type="number"
                  ></a-input>

                  <a-input
                    v-if="col == 'quantity'"
                    size="small"
                    :value="text"
                    @change="(e) => change_freight_change(e, record, col)"
                    type="number"
                  ></a-input>
                  <a-input
                    v-if="col == 'oil_consumption'"
                    size="small"
                    :value="text"
                    @change="(e) => change_freight_change(e, record, col)"
                    type="number"
                  ></a-input>

                  <a-input
                    v-if="col == 'ballast_length'"
                    size="small"
                    :value="text"
                    @change="(e) => change_freight_change(e, record, col)"
                    type="number"
                  ></a-input>
                  <a-input
                    v-if="col == 'loading_length'"
                    size="small"
                    :value="text"
                    @change="(e) => change_freight_change(e, record, col)"
                    type="number"
                  ></a-input>
                  <a-input
                    v-if="col == 'voyage_length'"
                    size="small"
                    :value="text"
                    @change="(e) => change_freight_change(e, record, col)"
                    type="number"
                  ></a-input>
                  <a-input
                    v-if="col == 'discharge_length'"
                    size="small"
                    :value="text"
                    @change="(e) => change_freight_change(e, record, col)"
                    type="number"
                  ></a-input>

                  <a-select v-if="col == 'exclude'" v-model="record.exclude">
                    <a-select-option key="true" value="true">true</a-select-option>
                    <a-select-option key="false" value="false">false</a-select-option>
                  </a-select>
                </template>
                <template v-else>{{ text }}</template>
              </div>
            </template>
          </a-table>
        </template>

        <template slot="total" slot-scope="text">
          {{ text }}
        </template>
      </a-table>
    </a-tab-pane>

    <a-tab-pane tab="Freight Parameters" key="6">
      <h3>Freight Parameters</h3>
      <a-divider></a-divider>
      <a-form>
        <a-form-item>
          <a-button type="primary" style="margin-right: 20px" @click="save_params"
            >Save All</a-button
          >
        </a-form-item>

        <a-form-item
          label="Ballast Length:"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 8 }"
        >
          <a-input v-model="params.ballast_length"></a-input>
        </a-form-item>
        <a-form-item
          label="Loading Length:"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 8 }"
        >
          <a-input v-model="params.loading_length"></a-input>
        </a-form-item>
        <a-form-item
          label="Voyage Length:"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 8 }"
        >
          <a-input v-model="params.voyage_length"></a-input>
        </a-form-item>
        <a-form-item
          label="Discharge Length:"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 8 }"
        >
          <a-input v-model="params.discharge_length"></a-input>
        </a-form-item>
        <a-form-item label="Quantity:" :labelCol="{ span: 5 }" :wrapperCol="{ span: 8 }">
          <a-input v-model="params.quantity"></a-input>
        </a-form-item>
        <a-form-item
          label="Oil Consumption:"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 8 }"
        >
          <a-input v-model="params.oil_consumption"></a-input>
        </a-form-item>
      </a-form>
    </a-tab-pane>

    <a-tab-pane tab="FFA Month" key="4">
      <h3>FFA Month</h3>
      <a-divider></a-divider>

      <a-button type="primary" style="margin-bottom: 20px" @click="save_ffa_month_cache"
        >Save All</a-button
      >
      <a-table
        size="small"
        :dataSource="required_ffa_month_list"
        :columns="ffa_month_cache_column"
        style="width: 500px"
        rowKey="name"
      >
        <template
          v-for="col in ['type', 'value', 'name']"
          :slot="col"
          slot-scope="text, record, index"
        >
          <div :key="col">
            <template v-if="col == 'value'">
              <a-input
                :value="text"
                type="number"
                @change="(e) => change_ffa_month_cache(e, record, index)"
              />
            </template>
            <template v-else>{{ text }}</template>
          </div>
        </template>
      </a-table>
    </a-tab-pane>

    <a-tab-pane tab="Bunker Month" key="5">
      <h3>Bunker Month</h3>
      <a-divider></a-divider>

      <a-button
        type="primary"
        style="margin-bottom: 20px"
        @click="save_bunker_month_cache"
        >Save All</a-button
      >
      <a-table
        size="small"
        :dataSource="required_bunker_month_list"
        :columns="bunker_month_cache_column"
        style="width: 500px"
        rowKey="name"
      >
        <template
          v-for="col in ['type', 'value', 'name']"
          :slot="col"
          slot-scope="text, record, index"
        >
          <div :key="col">
            <template v-if="col == 'value'">
              <a-input
                :value="text"
                type="number"
                @change="(e) => change_bunker_month(e, record, index)"
              />
            </template>
            <template v-else>{{ text }}</template>
          </div>
        </template>
      </a-table>
    </a-tab-pane>

    <a-tab-pane tab="Profit/Loss" key="7">
      <h3>Profit/Loss</h3>
      <a-divider></a-divider>

      <a-button type="primary" style="margin-bottom: 30px" @click="create_pl_table"
        >Generate</a-button
      >

      <a-tabs defaultActiveKey="2" tabPosition="left" @change="create_pl_table">
        <a-tab-pane tab="Vessels" key="1">
          <hot-table
            :data="v_table"
            :mergeCells="v_mergeCells"
            :rowHeaders="true"
            :colHeaders="true"
            width="100%"
            height="680"
            :cell="v_cell"
            licenseKey="non-commercial-and-evaluation"
          ></hot-table>
        </a-tab-pane>

        <a-tab-pane tab="Freights" key="2">
          <hot-table
            :data="fr_table"
            :mergeCells="fr_mergeCells"
            :rowHeaders="true"
            :colHeaders="true"
            width="100%"
            height="680"
            :cell="fr_cell"
            licenseKey="non-commercial-and-evaluation"
          ></hot-table>
        </a-tab-pane>
        <a-tab-pane tab="Result" key="3">
          <hot-table
            :data="r_table"
            :mergeCells="r_mergeCells"
            :rowHeaders="true"
            :colHeaders="true"
            width="100%"
            height="680"
            :cell="r_cell"
            licenseKey="non-commercial-and-evaluation"
          ></hot-table>
        </a-tab-pane>
      </a-tabs>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
import moment, { months } from "moment";
import { HotTable } from "@handsontable/vue";
import Handsontable from "handsontable";

import "handsontable/dist/handsontable.full.min.css";

export default {
  cacheChartersData: [],
  cacheFreightsData: [],

  components: {
    HotTable,
  },
  data() {
    return {
      modal_create_daily_hire_visible: false,
      charter: {
        vessel_name: "",
        start_obj: new moment(),
        end_obj: new moment().add(6, "month"),
        date_obj: new moment(),
        ratio: "",
        exclude: [],
      },
      charters: [],
      charter_columns: [
        {
          title: "ID#",
          dataIndex: "id",
          key: "id",
          sorter: (a, b) => a.id - b.id,
        },
        {
          title: "Vessel Name",
          dataIndex: "vessel_name",
          key: "vessel_name",
          scopedSlots: {
            customRender: "vessel_name",
          },
        },
        {
          title: "Created Date",
          dataIndex: "date",
          key: "date",
          scopedSlots: {
            customRender: "date",
          },
        },
        {
          title: "Charter Start",
          dataIndex: "start",
          key: "start",
          scopedSlots: {
            customRender: "start",
          },
        },
        {
          title: "Charter End",
          dataIndex: "end",
          key: "end",
          scopedSlots: {
            customRender: "end",
          },
        },
        {
          title: "Ratio%",
          dataIndex: "ratio",
          key: "ratio",
          scopedSlots: {
            customRender: "ratio",
          },
        },
        {
          title: "Exclude",
          dataIndex: "exclude",
          key: "exclude",
          scopedSlots: {
            customRender: "exclude",
          },
        },
        {
          title: "operation",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
        },
      ],

      earliest_chart_start: "",
      latest_chart_end: "",
      required_ffa_month_list: [],

      // freight table
      modal_create_freigth_visible: false,
      freight: {
        charterer: "",
        loading_start_obj: new moment().add(1, "month"),
        loading_period_start_obj: new moment().add(3, "month"),
        loading_period_end_obj: new moment().add(4, "month"),
        freight: "",
        pda: "",
        exclude: "false",
      },
      freights: [],
      freight_outter_column: [
        {
          title: "Charterer",
          dataIndex: "charterer",
          key: "charterer",
          scopedSlots: {
            customRender: "charterer",
          },
        },
        {
          title: "Total",
          dataIndex: "count",
          key: "count",
          scopedSlots: {
            customRender: "total",
          },
        },
      ],
      freight_column: [
        {
          title: "Est. Loading Start",
          dataIndex: "loading_start",
          key: "loading_start",
          scopedSlots: {
            customRender: "loading_start",
          },
        },
        {
          title: "Laycan Start",
          dataIndex: "loading_period_start",
          key: "loading_period_start",
          scopedSlots: {
            customRender: "loading_period_start",
          },
        },
        {
          title: "Laycan End",
          dataIndex: "loading_period_end",
          key: "loading_period_end",
          scopedSlots: {
            customRender: "loading_period_end",
          },
        },
        {
          title: "Ballast Length",
          dataIndex: "ballast_length",
          key: "ballast_length",
          scopedSlots: {
            customRender: "ballast_length",
          },
        },
        {
          title: "Loading Length",
          dataIndex: "loading_length",
          key: "loading_length",
          scopedSlots: {
            customRender: "loading_length",
          },
        },
        {
          title: "Voyage Length",
          dataIndex: "voyage_length",
          key: "voyage_length",
          scopedSlots: {
            customRender: "voyage_length",
          },
        },
        {
          title: "Discharge Length",
          dataIndex: "discharge_length",
          key: "discharge_length",
          scopedSlots: {
            customRender: "discharge_length",
          },
        },
        {
          title: "Quantity",
          dataIndex: "quantity",
          key: "quantity",
          scopedSlots: {
            customRender: "quantity",
          },
        },
        {
          title: "Oil Consumption",
          dataIndex: "oil_consumption",
          key: "oil_consumption",
          scopedSlots: {
            customRender: "oil_consumption",
          },
        },

        {
          title: "Freight",
          dataIndex: "freight",
          key: "freight",
          scopedSlots: {
            customRender: "freight",
          },
        },
        {
          title: "PDA",
          dataIndex: "pda",
          key: "pda",
          scopedSlots: {
            customRender: "pda",
          },
        },
        {
          title: "Exclude",
          dataIndex: "exclude",
          key: "exclude",
          scopedSlots: {
            customRender: "exclude",
          },
        },
        {
          title: "operation",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
        },
      ],
      freight_by_charter: [],

      // FFA history
      ffa_hist: [],
      ffa_hist_to_add: {
        date: new moment(),
        value: "",
      },
      ffa_hist_column: [
        {
          title: "Date",
          dataIndex: "date",
          key: "date",
          sorter: (a, b) => moment(a.date).diff(moment(b.date)),
        },
        {
          title: "Value",
          dataIndex: "value",
          key: "value",
          scopedSlots: {
            customRender: "value",
          },
        },
      ],

      //FFA month
      ffa_month_cache_to_add: {
        type: "ffa_month_cache",
        name: new moment(),
        value: "6600",
      },
      ffa_month_cache: [],
      ffa_month_cache_column: [
        {
          title: "ID#",
          dataIndex: "id",
          key: "id",
        },
        {
          title: "Type",
          dataIndex: "type",
          key: "type",
          scopedSlots: {
            customRender: "type",
          },
        },
        {
          title: "Name",
          dataIndex: "name",
          key: "name",
          scopedSlots: {
            customRender: "name",
          },
        },
        {
          title: "Value",
          dataIndex: "value",
          key: "value",
          scopedSlots: {
            customRender: "value",
          },
        },
      ],

      //bunker month
      bunker_month_cache: [],
      required_bunker_month_list: [],
      bunker_month_cache_column: [
        {
          title: "ID#",
          dataIndex: "id",
          key: "id",
        },
        {
          title: "Type",
          dataIndex: "type",
          key: "type",
          scopedSlots: {
            customRender: "type",
          },
        },
        {
          title: "Name",
          dataIndex: "name",
          key: "name",
          scopedSlots: {
            customRender: "name",
          },
        },
        {
          title: "Value",
          dataIndex: "value",
          key: "value",
          scopedSlots: {
            customRender: "value",
          },
        },
      ],

      // Parameters
      params: {
        ballast_length: "",
        loading_length: "",
        voyage_length: "",
        discharge_length: "",
        quantity: "",
        oil_consumption: "",
      },

      // PL table:
      v_table: [
        ["Month", "FFA Value"],
        ["", " ", "Days"],
      ],
      fr_table: [
        ["Month", "FFA Value"],
        ["", " "],
      ],
      r_table: [
        ["Month", "FFA Value"],
        ["", " "],
      ],
      v_mergeCells: [],
      v_cell: [],
      fr_mergeCells: [],
      fr_cell: [],
      r_mergeCells: [],
      r_cell: [],
    };
  },

  methods: {
    refresh() {
      this.charters = [];
      this.$http.post(this.$store.state.base_url + "/charter/r", {}).then((res) => {
        if (res.data.status == 1) {
          this.charters = res.data.data;
          this.charters.forEach((c) => {
            c.date_obj = new moment(c.date);
            c.start_obj = new moment(c.start);
            c.end_obj = new moment(c.end);

            c.month_array = [];
            var e = c.end_obj.clone();
            var i = c.start_obj.clone();
            e.add(1, "month");
            do {
              c.month_array.push(i.format("YYYY-MM"));
              i.add(1, "month");
            } while (i.format("YYYY-MM") !== e.format("YYYY-MM"));
          });
          // sort
          this.charters.sort((a, b) => {
            return a.start_obj.diff(b.start_obj);
          });
          this.cacheChartersData = JSON.parse(JSON.stringify(this.charters));

          // find all charter month begin and end according to charter
          var starts = this.charters.map((c) => {
            return moment(c.start, "YYYY-MM-DD");
          });
          this.earliest_chart_start = moment.min(starts);
          var ends = this.charters.map((c) => {
            return moment(c.end, "YYYY-MM-DD");
          });
          this.latest_chart_end = moment.max(ends);

          ///////////////////////////////////////////////////////////

          this.freights = [];
          this.freight_by_charter = [];
          this.$http.post(this.$store.state.base_url + "/cargo/r", {}).then((res) => {
            if (res.data.status == 1) {
              this.freights = res.data.data;
              this.required_bunker_month_list = [];
              this.freights.forEach((f) => {
                f.loading_start_obj = new moment(f.loading_start);
                f.loading_period_start_obj = new moment(f.loading_period_start);
                f.loading_period_end_obj = new moment(f.loading_period_end);
                f.exclude = f.exclude ? "true" : "false";

                f.whole_start_obj = f.loading_start_obj
                  .clone()
                  .subtract(f.ballast_length, "day")
                  .add(1, "day");
                f.whole_end_obj = f.loading_start_obj
                  .clone()
                  .add(
                    Number.parseInt(f.loading_length) +
                      Number.parseInt(f.voyage_length) +
                      Number.parseInt(f.discharge_length) +
                      1,
                    "day"
                  )
                  .subtract(1, "day");
                var find = this.required_bunker_month_list.find((r) => {
                  return r.name == f.whole_start_obj.format("YYYY-MM");
                });
                if (!find) {
                  this.required_bunker_month_list.push({
                    name: f.whole_start_obj.format("YYYY-MM"),
                    value: "",
                    type: "bunker_month",
                  });
                }
                // create freigt by charterers
                find = this.freight_by_charter.find((f_c) => {
                  return f_c.charterer == f.charterer;
                });
                if (find) {
                  var f_ = this.freight_by_charter.filter(
                    (f_c) => f_c.charterer == f.charterer
                  )[0];
                  f_.count = f_.count + 1;
                } else {
                  this.freight_by_charter.push({
                    charterer: f.charterer,
                    count: 1,
                  });
                }
              });
              this.cacheFreightsData = JSON.parse(JSON.stringify(this.freights));

              // find all freights month begin and end
              var loading_starts = this.freights.map((f) => {
                return f.whole_start_obj.clone();
              });
              var earliest_in_freight = moment.min([...loading_starts]);
              this.earliest_chart_start = moment.min(
                this.earliest_chart_start,
                earliest_in_freight
              );
              //// fill required ffa month lists
              var i = this.earliest_chart_start.clone();
              var e = this.latest_chart_end.clone();
              this.required_ffa_month_list = [];
              do {
                this.required_ffa_month_list.push({
                  name: i.format("YYYY-MM"),
                });
                i.add(1, "month");
              } while (i.format("YYYY-MM") !== e.format("YYYY-MM"));
              this.required_ffa_month_list.push({
                name: i.format("YYYY-MM"),
              });

              // nested networks calls
              // Fit FFA month
              this.$http.post(this.$store.state.base_url + "/cache/r", {}).then((res) => {
                if (res.data.status == 1) {
                  this.ffa_month_cache = JSON.parse(JSON.stringify(res.data.data));
                  this.ffa_month_cache = this.ffa_month_cache.filter(
                    (f) => f.type == "ffa_month"
                  );
                  this.required_ffa_month_list.forEach((r) => {
                    r.type = "ffa_month";
                    r.value = "";
                    this.ffa_month_cache.forEach((f) => {
                      if (f.name == r.name) {
                        r.id = f.id;
                        r.name = f.name;
                        r.value = f.value + "";
                      }
                    });
                  });
                  //sort
                  this.required_bunker_month_list.sort((a, b) => {
                    return moment(a.name + "-01").diff(b.name + "-01");
                  });
                  this.$forceUpdate();
                }
              });

              // nested networks calls
              // Fit Bunker month
              this.$http.post(this.$store.state.base_url + "/cache/r", {}).then((res) => {
                if (res.data.status == 1) {
                  this.bunker_month_cache = JSON.parse(JSON.stringify(res.data.data));
                  this.bunker_month_cache = this.bunker_month_cache.filter(
                    (f) => f.type == "bunker_month"
                  );
                  this.required_bunker_month_list.forEach((r) => {
                    r.type = "bunker_month";
                    r.value = "";
                    this.bunker_month_cache.forEach((b) => {
                      if (b.name == r.name) {
                        r.id = b.id;
                        r.name = b.name;
                        r.value = b.value + "";
                      }
                    });
                  });
                  //sort
                  this.required_bunker_month_list.sort((a, b) => {
                    return moment(a.name + "-01").diff(b.name + "-01");
                  });
                  this.$forceUpdate();
                }
              });
            }
          });
        }
      });

      // fetch freight parameter
      this.$http.post(this.$store.state.base_url + "/parameter/r", {}).then((res) => {
        if (res.data.status == 1) {
          this.params.ballast_length = res.data.data.filter(
            (d) => d.key == "ballast_length"
          )[0].value;
          this.params.loading_length = res.data.data.filter(
            (d) => d.key == "loading_length"
          )[0].value;
          this.params.voyage_length = res.data.data.filter(
            (d) => d.key == "voyage_length"
          )[0].value;
          this.params.discharge_length = res.data.data.filter(
            (d) => d.key == "discharge_length"
          )[0].value;

          this.params.quantity = res.data.data.filter(
            (d) => d.key == "quantity"
          )[0].value;

          this.params.oil_consumption = res.data.data.filter(
            (d) => d.key == "oil_consumption"
          )[0].value;

          this.freight.ballast_length = this.params.ballast_length;
          this.freight.loading_length = this.params.loading_length;
          this.freight.voyage_length = this.params.voyage_length;
          this.freight.discharge_length = this.params.discharge_length;
          this.freight.quantity = this.params.quantity;
          this.freight.oil_consumption = this.params.oil_consumption;
        }
      });
    },
    //Daily Hire Table Operation
    save_dh(id) {
      const newData = [...this.charters];
      const target = newData.filter((item) => id === item.id)[0];
      var data = JSON.parse(JSON.stringify(target));
      delete data.start_obj;
      delete data.end_obj;
      delete data.date_obj;
      delete data.editable;
      delete data.lastupdate;
      delete data.lasteditor;
      delete data.month_array;
      // save to database
      this.$http.post(this.$store.state.base_url + "/charter/u", data).then((res) => {
        if (res.data.status == 1) {
          this.refresh();
        }
      });
    },
    cancel_dh_change(key) {
      const newData = [...this.charters];
      const target = newData.filter((item) => key === item.id)[0];
      if (target) {
        Object.assign(
          target,
          this.cacheChartersData.filter((item) => key === item.id)[0]
        );
        console.log(target);
        delete target.editable;
        this.charters = newData;
      }
    },
    change_dh_change(e, record, col) {
      const newData = [...this.charters];
      const target = newData.filter((item) => record.id === item.id)[0];
      target[col] = target[col + "_obj"].format("YYYY-MM-DD");
    },
    edit_dh(key) {
      const newData = [...this.charters];
      const target = newData.filter((item) => key === item.id)[0];
      if (target) {
        target.editable = true;
        this.charters = newData;
      }
    },
    delete_dh(id) {
      this.$http
        .post(this.$store.state.base_url + "/charter/d", { id: id })
        .then((res) => {
          if (res.data.status == 1) {
            this.refresh();
          }
        });
    },
    submit_create_dh() {
      this.charter.start = this.charter.start_obj.format("YYYY-MM-DD");
      this.charter.end = this.charter.end_obj.format("YYYY-MM-DD");
      this.charter.date = this.charter.date_obj.format("YYYY-MM-DD");
      delete this.charter.start_obj;
      delete this.charter.end_obj;
      delete this.charter.date_obj;

      this.$http
        .post(this.$store.state.base_url + "/charter/c", this.charter)
        .then((res) => {
          if (res.data.status == 1) {
            this.charter = {
              vessel_name: "",
              start_obj: moment(),
              end_obj: moment().add("month", 6),
              date_obj: moment(),
              ratio: "",
            };
            this.refresh();
            this.modal_create_daily_hire_visible = false;
          }
        });
    },

    // freight table operation
    submit_freight_create() {
      this.freight.loading_start = this.freight.loading_start_obj.format("YYYY-MM-DD");
      this.freight.loading_period_start = this.freight.loading_period_start_obj.format(
        "YYYY-MM-DD"
      );
      this.freight.loading_period_end = this.freight.loading_period_end_obj.format(
        "YYYY-MM-DD"
      );
      delete this.freight.loading_start_obj;
      delete this.freight.loading_period_start_obj;
      delete this.freight.loading_period_end_obj;

      this.$http
        .post(this.$store.state.base_url + "/cargo/c", this.freight)
        .then((res) => {
          if (res.data.status == 1) {
            this.freight = {
              charterer: "",
              loading_start_obj: new moment().add(1, "month"),
              loading_period_start_obj: new moment().add(3, "month"),
              loading_period_end_obj: new moment().add(4, "month"),
              freight: "",
              pda: "",
              exclude: "false",
            };
            this.refresh();
            this.modal_create_freigth_visible = false;
          }
        });
    },
    save_freight(key) {
      const newData = [...this.freights];
      const target = newData.filter((item) => key === item.id)[0];
      var data = JSON.parse(JSON.stringify(target));
      delete data.loading_start_obj;
      delete data.loading_period_start_obj;
      delete data.loading_period_end_obj;
      delete data.lastupdate;
      delete data.lasteditor;
      // save to database
      this.$http.post(this.$store.state.base_url + "/cargo/u", data).then((res) => {
        if (res.data.status == 1) {
          this.refresh();
        }
      });
    },
    cancel_freight_change(key) {
      const newData = [...this.freights];
      const target = newData.filter((item) => key === item.id)[0];
      if (target) {
        Object.assign(
          target,
          this.cacheFreightsData.filter((item) => key === item.id)[0]
        );
        delete target.editable;
        this.freights = newData;
      }
    },
    delete_freight(id) {
      this.$http.post(this.$store.state.base_url + "/cargo/d", { id: id }).then((res) => {
        if (res.data.status == 1) {
          this.refresh();
        }
      });
    },
    edit_freight(key) {
      const newData = [...this.freights];
      const target = newData.filter((item) => key === item.id)[0];
      if (target) {
        target.editable = true;
        this.freights = newData;
      }
    },
    change_freight_change(e, record, col) {
      var target = this.freights.filter((item) => record.id === item.id)[0];
      if (
        (col == "loading_start") |
        (col == "loading_period_start") |
        (col == "loading_period_end")
      ) {
        target[col] = target[col + "_obj"].format("YYYY-MM-DD");
      } else {
        target[col] = e.target.value;
      }
      this.$forceUpdate();
    },

    // CACHE////////////////////////////////////
    // FFA month cache
    save_ffa_month_cache() {
      this.required_ffa_month_list.forEach((r) => {});
      this.$http
        .post(this.$store.state.base_url + "/cache/e/m", this.required_ffa_month_list)
        .then((res) => {
          if (res.data.status == 1) {
            this.refresh();
          }
        });
    },
    change_ffa_month_cache(e, record, index) {
      // sant-vue very buggy here
      // destroy v-model mvvc
      // :value / @change /forceupdate
      // if you use basic input everthing is fine
      record.value = e.target.value;
      this.$forceUpdate();
    },

    // Bunker month cache ////////////////////////
    change_bunker_month(e, record, index) {
      record.value = e.target.value;
      this.$forceUpdate();
    },
    save_bunker_month_cache() {
      this.required_bunker_month_list.forEach((r) => {});
      this.$http
        .post(this.$store.state.base_url + "/cache/e/m", this.required_bunker_month_list)
        .then((res) => {
          if (res.data.status == 1) {
            this.refresh();
          }
        });
    },
    // CACHE////////////////////////////////////

    // add parameter function
    add_params() {
      this.$http
        .post(this.$store.state.base_url + "/parameter/e", {
          key: "oil_consumption",
          value: "2200",
        })
        .then((res) => {
          if (res.data.status == 1) {
            this.refresh();
          }
        });
    },
    save_params() {
      var arr = [];
      for (let [key, value] of Object.entries(this.params)) {
        var ele = {};
        ele[key] = value;
        arr.push({ key: key, value: value });
      }
      this.$http.post(this.$store.state.base_url + "/parameter/e/m", arr).then((res) => {
        if (res.data.status == 1) {
          this.refresh();
        }
      });
    },

    // matrix manipulation
    add_row(matrix, index) {
      var length = matrix[0].length;
      var row = new Array(matrix[0].length).fill("");
      matrix.splice(index, 0, row);
      return matrix;
    },
    add_col(matrix, index) {
      matrix.forEach((r) => {
        r.splice(index, 0, "");
      });
      return matrix;
    },
    clear_table() {
      this.v_table = [
        ["Month", "FFA Value"],
        ["", " "],
      ];
      this.fr_table = [
        ["Month", "FFA Value"],
        ["", " "],
      ];
      this.r_table = [
        ["Month", "FFA Value"],
        ["", " "],
      ];
      this.v_mergeCells = [];
      this.v_cell = [];

      this.fr_mergeCells = [];
      this.fr_cell = [];

      this.r_mergeCells = [];
      this.r_cell = [];
    },

    create_v_table() {
      var start_row = 2;
      var row_index = start_row;
      var col_index = 0;

      this.required_ffa_month_list.forEach((r) => {
        this.add_row(this.v_table, row_index);
        this.v_table[row_index][col_index] = r.name;
        this.v_table[row_index][col_index + 1] = r.value;
        row_index = row_index + 1;
      });
      col_index = col_index + 2;

      this.charters.forEach((c) => {
        this.add_col(this.v_table, col_index);
        this.add_col(this.v_table, col_index);

        // format
        this.v_mergeCells.push({
          row: 0,
          col: col_index,
          rowspan: 1,
          colspan: 2,
        });
        this.v_cell.push({ row: 0, col: col_index, className: "htCenter" });
        // headers
        this.v_table[0][col_index] = c.vessel_name;
        this.v_table[1][col_index] = "Days";
        this.v_table[1][col_index + 1] = "Val";
        this.v_cell.push({ row: 1, col: col_index, className: "htCenter" });
        this.v_cell.push({ row: 1, col: col_index + 1, className: "htCenter" });

        // fill according to month
        row_index = start_row;
        try {
          this.required_ffa_month_list.forEach((r) => {
            var start = new moment(r.name + "-01")
              .startOf("month")
              .hours(0)
              .minutes(0)
              .seconds(0)
              .milliseconds(0);
            var end = new moment(r.name + "-01")
              .endOf("month")
              .hours(0)
              .minutes(0)
              .seconds(0)
              .milliseconds(0);

            // find end
            if (c.end_obj.isBetween(start, end, null, [])) {
              // end and start within the same month
              if (c.start_obj.isBetween(start, end, null, [])) {
                this.v_table[row_index][col_index] =
                  Math.ceil(c.end_obj.diff(c.start_obj, "days", true)) + 1;
              } else {
                this.v_table[row_index][col_index] =
                  Math.ceil(c.end_obj.diff(start, "days", true)) + 1;
              }
              this.v_table[row_index][col_index + 1] = (
                (Number.parseInt(r.value) * Number.parseInt(c.ratio)) /
                100
              ).toFixed(0);
              throw new Error("end");
            }

            // find between
            if (
              start.isBetween(c.start_obj, c.end_obj, null, []) &&
              end.isBetween(c.start_obj, c.end_obj, null, [])
            ) {
              this.v_table[row_index][col_index] =
                Math.ceil(end.diff(start, "days", true)) + 1;
              this.v_table[row_index][col_index + 1] = (
                (Number.parseInt(r.value) * Number.parseInt(c.ratio)) /
                100
              ).toFixed(0);
              row_index = row_index + 1;
              return;
            }
            // find first
            if (c.start_obj.isBetween(start, end, null, [])) {
              this.v_table[row_index][col_index] =
                Math.ceil(end.diff(c.start_obj, "days", true)) + 1;
              this.v_table[row_index][col_index + 1] = (
                (Number.parseInt(r.value) * Number.parseInt(c.ratio)) /
                100
              ).toFixed(0);
              row_index = row_index + 1;
              return;
            }
            row_index = row_index + 1;
          });
        } catch (e) {
          console.log(e);
        }
        col_index = col_index + 2;
      });

      //sum totals
      this.add_col(this.v_table, col_index);
      this.add_col(this.v_table, col_index);
      // format
      this.v_mergeCells.push({
        row: 0,
        col: col_index,
        rowspan: 1,
        colspan: 2,
      });
      this.v_cell.push({ row: 0, col: col_index, className: "htCenter" });
      // headers
      this.v_table[0][col_index] = "Total";
      this.v_table[1][col_index] = "Days";
      this.v_table[1][col_index + 1] = "W. Average ";
      this.v_cell.push({ row: 1, col: col_index, className: "htCenter" });
      this.v_cell.push({ row: 1, col: col_index + 1, className: "htCenter" });

      var vessel_col_start = 2;
      for (var i = 0; i < this.required_ffa_month_list.length; i++) {
        var total_days_per_veseel = 0;
        var sumproduct_per_vessel = 0;
        for (var j = 0; j < this.charters.length; j++) {
          if (this.v_table[i + 2][2 * j + vessel_col_start]) {
            total_days_per_veseel =
              total_days_per_veseel +
              Number.parseInt(this.v_table[i + 2][2 * j + vessel_col_start]);
            sumproduct_per_vessel =
              sumproduct_per_vessel +
              Number.parseInt(this.v_table[i + 2][2 * j + vessel_col_start]) *
                Number.parseInt(this.v_table[i + 2][2 * j + vessel_col_start + 1]);
          }
        }
        if (total_days_per_veseel != 0) {
          this.v_table[i + 2][col_index] = total_days_per_veseel;
          this.v_table[i + 2][col_index + 1] = (
            sumproduct_per_vessel / total_days_per_veseel
          ).toFixed(0);
          this.v_cell.push({
            row: i + 2,
            col: col_index + 1,
            className: "htRight",
          });
        }
      }
    },

    create_fr_table() {
      var start_row = 2;
      var row_index = start_row;
      var col_index = 0;

      this.required_ffa_month_list.forEach((r) => {
        this.add_row(this.fr_table, row_index);
        this.fr_table[row_index][col_index] = r.name;
        this.fr_table[row_index][col_index + 1] = r.value;
        row_index = row_index + 1;
      });
      col_index = col_index + 2;

      // initiate summary by charter
      var summary_by_charterer = [];
      this.freight_by_charter.forEach((f_b_c) => {
        var s = {
          charterer: f_b_c.charterer,
          month_list: [],
        };
        this.required_ffa_month_list.forEach((r) => {
          s.month_list.push({
            name: r.name,
            days: null,
            breakeven: null,
          });
        });
        summary_by_charterer.push(s);
      });

      summary_by_charterer.forEach((s) => {
        var by_charterer = this.freights.filter((f) => s.charterer == f.charterer);
        by_charterer.forEach((by) => {
          var total_length = by.whole_end_obj.diff(by.whole_start_obj, "days", false) - 1;
          var oil_px = Number.parseInt(
            this.required_bunker_month_list.filter((b) => {
              return by.whole_start_obj.format("YYYY-MM") == b.name;
            })[0].value
          );
          var break_even = (
            (Number.parseInt(by.freight) * Number(by.quantity) -
              Number.parseInt(by.pda) -
              Number.parseInt(by.oil_consumption) * oil_px) /
            total_length
          ).toFixed(0);
          try {
            s.month_list.forEach((m) => {
              var start = new moment(m.name + "-01")
                .startOf("month")
                .hours(0)
                .minutes(0)
                .seconds(0)
                .milliseconds(0);
              var end = new moment(m.name + "-01")
                .endOf("month")
                .hours(0)
                .minutes(0)
                .seconds(0)
                .milliseconds(0);

              // find end
              if (by.whole_end_obj.isBetween(start, end, null, [])) {
                var add = Math.ceil(by.whole_end_obj.diff(start, "days", true)) + 1;
                if (m.days) {
                  m.breakeven =
                    (m.breakeven * m.days + break_even * add) / (m.days + add);
                  m.breakeven = m.breakeven.toFixed(0);
                  m.days = m.days + add;
                } else {
                  m.days = Math.ceil(by.whole_end_obj.diff(start, "days", true)) + 1;
                  m.breakeven = break_even;
                }
                throw new Error("end");
              }
              // find between
              if (
                start.isBetween(by.whole_start_obj, by.whole_end_obj, null, []) &&
                end.isBetween(by.whole_start_obj, by.whole_end_obj, null, [])
              ) {
                let add = Math.ceil(end.diff(start, "days", true)) + 1;
                if (m.days) {
                  m.breakeven =
                    (m.breakeven * m.days + break_even * add) / (m.days + add);
                  m.breakeven = m.breakeven.toFixed(0);
                  m.days = m.days + add;
                } else {
                  m.days = Math.ceil(end.diff(start, "days", true)) + 1;
                  m.breakeven = break_even;
                }
                return;
              }
              // find first
              if (by.whole_start_obj.isBetween(start, end, null, [])) {
                let add = Math.ceil(end.diff(by.whole_start_obj, "days", true)) + 1;
                if (m.days) {
                  m.breakeven =
                    (m.breakeven * m.days + break_even * add) / (m.days + add);
                  m.breakeven = m.breakeven.toFixed(0);
                  m.days = m.days + add;
                } else {
                  m.days = Math.ceil(end.diff(by.whole_start_obj, "days", true)) + 1;
                  m.breakeven = break_even;
                }
                return;
              }
            });
          } catch (err) {
            console.log(err);
          }
        });
      });

      // fill the summary by charterer
      summary_by_charterer.forEach((s) => {
        this.add_col(this.fr_table, col_index);
        this.add_col(this.fr_table, col_index);
        // format
        this.fr_mergeCells.push({
          row: 0,
          col: col_index,
          rowspan: 1,
          colspan: 2,
        });
        this.fr_cell.push({ row: 0, col: col_index, className: "htCenter" });
        // headers
        this.fr_table[0][col_index] = s.charterer;
        this.fr_table[1][col_index] = "Days";
        this.fr_table[1][col_index + 1] = "Break Even";
        this.fr_cell.push({ row: 1, col: col_index, className: "htCenter" });
        this.fr_cell.push({
          row: 1,
          col: col_index + 1,
          className: "htCenter",
        });

        row_index = start_row;
        s.month_list.forEach((m) => {
          this.fr_table[row_index][col_index] = m.days;
          this.fr_table[row_index][col_index + 1] = m.breakeven;
          row_index = row_index + 1;
        });
        col_index = col_index + 2;
      });

      // this.freights.forEach(f => {
      //   this.add_col(this.fr_table, col_index);
      //   this.add_col(this.fr_table, col_index);

      //   // format
      //   this.fr_mergeCells.push({
      //     row: 0,
      //     col: col_index,
      //     rowspan: 1,
      //     colspan: 2
      //   });
      //   this.fr_cell.push({ row: 0, col: col_index, className: "htCenter" });
      //   // headers
      //   this.fr_table[0][col_index] = f.charterer;
      //   this.fr_table[1][col_index] = "Days";
      //   this.fr_table[1][col_index + 1] = "Break Even";
      //   this.fr_cell.push({ row: 1, col: col_index, className: "htCenter" });
      //   this.fr_cell.push({
      //     row: 1,
      //     col: col_index + 1,
      //     className: "htCenter"
      //   });

      //   // fill according to month
      //   row_index = start_row;
      //   try {
      //     this.required_ffa_month_list.forEach(r => {
      //       var total_length =
      //         f.whole_end_obj.diff(f.whole_start_obj, "days", false) - 1;
      //       var oil_px = Number.parseInt(
      //         this.required_bunker_month_list.filter(b => {
      //           return f.whole_start_obj.format("YYYY-MM") == b.name;
      //         })[0].value
      //       );
      //       var break_even = (
      //         (Number.parseInt(f.freight) * Number(f.quantity) -
      //           Number.parseInt(f.pda) -
      //           Number.parseInt(f.oil_consumption) * oil_px) /
      //         total_length
      //       ).toFixed(0);
      //       var start = new moment(r.name + "-01")
      //         .startOf("month")
      //         .hours(0)
      //         .minutes(0)
      //         .seconds(0)
      //         .milliseconds(0);
      //       var end = new moment(r.name + "-01")
      //         .endOf("month")
      //         .hours(0)
      //         .minutes(0)
      //         .seconds(0)
      //         .milliseconds(0);

      //       // find end
      //       if (f.whole_end_obj.isBetween(start, end, null, [])) {
      //         this.fr_table[row_index][col_index] =
      //           Math.ceil(f.whole_end_obj.diff(start, "days", true)) + 1;
      //         this.fr_table[row_index][col_index + 1] = break_even;
      //         throw new Error("end");
      //       }
      //       // find between
      //       if (
      //         start.isBetween(f.whole_start_obj, f.whole_end_obj, null, []) &&
      //         end.isBetween(f.whole_start_obj, f.whole_end_obj, null, [])
      //       ) {
      //         this.fr_table[row_index][col_index] =
      //           Math.ceil(end.diff(start, "days", true)) + 1;
      //         this.fr_table[row_index][col_index + 1] = break_even;

      //         row_index = row_index + 1;
      //         return;
      //       }
      //       // find first
      //       if (f.whole_start_obj.isBetween(start, end, null, [])) {
      //         this.fr_table[row_index][col_index] =
      //           Math.ceil(end.diff(f.whole_start_obj, "days", true)) + 1;
      //         this.fr_table[row_index][col_index + 1] = break_even;
      //         row_index = row_index + 1;
      //         return;
      //       }
      //       row_index = row_index + 1;
      //     });
      //   } catch {}
      //   col_index = col_index + 2;
      // });

      //sum totals
      this.add_col(this.fr_table, col_index);
      this.add_col(this.fr_table, col_index);
      // format
      this.fr_mergeCells.push({
        row: 0,
        col: col_index,
        rowspan: 1,
        colspan: 2,
      });
      this.fr_cell.push({ row: 0, col: col_index, className: "htCenter" });
      // headers
      this.fr_table[0][col_index] = "Total";
      this.fr_table[1][col_index] = "Days";
      this.fr_table[1][col_index + 1] = "Average Breakeven";
      this.fr_cell.push({ row: 1, col: col_index, className: "htCenter" });
      this.fr_cell.push({ row: 1, col: col_index + 1, className: "htCenter" });

      var freight_col_start = 2;
      for (var i = 0; i < this.required_ffa_month_list.length; i++) {
        var total_days_per_freight = 0;
        var sumproduct_per_freight = 0;
        for (var j = 0; j < this.freights.length; j++) {
          if (this.fr_table[i + 2][2 * j + freight_col_start]) {
            total_days_per_freight =
              total_days_per_freight +
              Number.parseInt(this.fr_table[i + 2][2 * j + freight_col_start]);
            sumproduct_per_freight =
              sumproduct_per_freight +
              Number.parseInt(this.fr_table[i + 2][2 * j + freight_col_start]) *
                Number.parseInt(this.fr_table[i + 2][2 * j + freight_col_start + 1]);
          }
        }
        if (total_days_per_freight != 0) {
          this.fr_table[i + 2][col_index] = total_days_per_freight;
          this.fr_table[i + 2][col_index + 1] = (
            sumproduct_per_freight / total_days_per_freight
          ).toFixed(0);
          this.fr_cell.push({
            row: i + 2,
            col: col_index + 1,
            className: "htRight",
          });
        }
      }
    },

    create_r_table() {
      var start_row = 2;
      var row_index = start_row;
      var col_index = 0;

      this.required_ffa_month_list.forEach((r) => {
        this.add_row(this.r_table, row_index);
        this.r_table[row_index][col_index] = r.name;
        this.r_table[row_index][col_index + 1] = r.value;
        row_index = row_index + 1;
      });

      // fill vessel
      col_index = col_index + 2;
      this.add_col(this.r_table, col_index);
      this.add_col(this.r_table, col_index);

      this.r_mergeCells.push({
        row: 0,
        col: col_index,
        colspan: 2,
        rowspan: 1,
      });

      this.r_table[0][col_index] = "Vessels";
      this.r_table[1][col_index] = "Days";
      this.r_table[1][col_index + 1] = "Average Value";
      this.r_cell.push({
        row: 0,
        col: col_index,
        className: "htCenter",
      });

      for (var i = 0; i < this.v_table.length - 2; i++) {
        var length = this.v_table[0].length;
        this.r_table[i + 2][col_index] = this.v_table[i + 2][length - 2];
        this.r_table[i + 2][col_index + 1] = this.v_table[i + 2][length - 1];
        this.r_cell.push({
          row: i + 2,
          col: col_index + 1,
          className: "htRight",
        });
      }

      // fill freight
      col_index = col_index + 2;
      this.add_col(this.r_table, col_index);
      this.add_col(this.r_table, col_index);

      this.r_mergeCells.push({
        row: 0,
        col: col_index,
        colspan: 2,
        rowspan: 1,
      });

      this.r_table[0][col_index] = "Freights";
      this.r_table[1][col_index] = "Days";
      this.r_table[1][col_index + 1] = "Average B/E";
      this.r_cell.push({
        row: 0,
        col: col_index,
        className: "htCenter",
      });
      for (let i = 0; i < this.fr_table.length - 2; i++) {
        let length = this.fr_table[0].length;
        this.r_table[i + 2][col_index] = this.fr_table[i + 2][length - 2];
        this.r_table[i + 2][col_index + 1] = this.fr_table[i + 2][length - 1];
        this.r_cell.push({
          row: i + 2,
          col: col_index + 1,
          className: "htRight",
        });
      }

      // Surplus/Deficit
      col_index = col_index + 2;
      this.add_col(this.r_table, col_index);
      this.add_col(this.r_table, col_index);
      this.add_col(this.r_table, col_index);

      this.r_mergeCells.push({
        row: 0,
        col: col_index,
        colspan: 3,
        rowspan: 1,
      });

      this.r_table[0][col_index] = "Summary";
      this.r_table[1][col_index] = "Surplus";
      this.r_table[1][col_index + 1] = "Deficit";
      this.r_table[1][col_index + 2] = "Profit / Loss";
      this.r_cell.push({
        row: 0,
        col: col_index,
        className: "htCenter",
      });

      for (let i = 0; i < this.r_table.length - 2; i++) {
        let length = this.r_table[0].length;
        var diff = this.r_table[i + 2][2] - this.r_table[i + 2][4];

        // skip if empty
        if (this.r_table[i + 2][2] == "" && this.r_table[i + 2][4] == "") {
          continue;
        }
        if (diff > 0) {
          this.r_table[i + 2][col_index] = diff;
        } else {
          this.r_table[i + 2][col_index + 1] = diff;
        }

        if (diff > 0 && this.r_table[i + 2][4] != "") {
          this.r_table[i + 2][col_index + 2] = Number.parseInt(
            (Number.parseInt(this.r_table[i + 2][5]) -
              Number.parseInt(this.r_table[i + 2][3])) *
              Number.parseInt(this.r_table[i + 2][6])
          ).toLocaleString("en-US");
          this.r_cell.push({
            row: i + 2,
            col: col_index + 2,
            className: "htRight",
          });
        }
      }
    },

    create_pl_table() {
      this.clear_table();
      this.create_v_table();
      this.create_fr_table();
      this.create_r_table();
    },
  },
  mounted() {
    // this.add_row(this.pl_table, 0);
    // //only if insert
    // this.move_cell_by_row(this.mergeCells,this.cell)
    // this.add_col(this.pl_table, 5);
    // //only if insert
    // this.move_cell_by_col(this.mergeCells,this.cell)

    this.refresh();
  },
};
</script>
<style scoped></style>
